var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[_c('div',{staticClass:"home-content content"},[_c('div',{staticClass:"hc-top clear"},[_c('banner'),_c('art')],1),_c('div',{staticClass:"hc-icon clear"},[_c('icon')],1),_c('div',{staticClass:"hc-title"},[_c('template-content')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }